"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function attachScript(src, tryRequireJs) {
    if (tryRequireJs === void 0) { tryRequireJs = false; }
    if (tryRequireJs) {
        var win = window;
        if (win.define && win.define.amd) {
            var viewerWindow_1 = win;
            return new Promise(function (resolve) {
                // viewer require-js found
                viewerWindow_1.require([src], resolve);
            });
        }
    }
    return new Promise(function (resolve) {
        var body = document.body;
        var script = document.createElement('script');
        script.src = src;
        var done = false;
        // Attach handlers for all browsers
        script.onload = script.onreadystatechange = function () {
            if (!done &&
                (!this.readyState ||
                    this.readyState === 'loaded' ||
                    this.readyState === 'complete')) {
                done = true;
                resolve();
                script.onload = script.onreadystatechange = null;
                if (body && script.parentNode) {
                    body.removeChild(script);
                }
            }
        };
        body.appendChild(script);
    });
}
exports.default = attachScript;
//# sourceMappingURL=attach-script.js.map